/**
 * Схема для GET `auth/permission` — список permission'ов (organization /
 * theater / event), в которых юзер может работать после логина.
 *
 * Один user может иметь много permission'ов — например быть кассиром
 * в театре А и менеджером в театре Б. После логина показываем picker,
 * юзер выбирает permission, мы меняем его на scoped-токен.
 */

import {z} from 'zod';

import {UserRoleSchema} from '@services/auth/login';

const NamedSchema = z
  .object({
    id: z.number(),
    title: z.string().nullable().optional(),
  })
  .passthrough();

export const PermissionSchema = z
  .object({
    id: z.number(),
    role: UserRoleSchema,
    country: NamedSchema.nullable().optional(),
    organization: NamedSchema.nullable().optional(),
    theater: NamedSchema.nullable().optional(),
    event: NamedSchema.nullable().optional(),
    events: z.array(NamedSchema).nullable().optional().default([]),
    session: z
      .object({
        id: z.number(),
        dateTime: z.string().nullable().optional(),
        slug: z.string().nullable().optional(),
        event: z.object({title: z.string().nullable().optional()}).passthrough(),
      })
      .passthrough()
      .nullable()
      .optional(),
    percent: z.union([z.number(), z.string()]).nullable().optional(),
    byCountry: z.boolean().optional(),
    isInvitationsEnabled: z.boolean().optional(),
  })
  .passthrough();
export type Permission = z.infer<typeof PermissionSchema>;

export const GetPermissionsResponseSchema = z.array(PermissionSchema);
export type GetPermissionsResponse = z.infer<typeof GetPermissionsResponseSchema>;
